__turbopack_context__.v({
  "Cont": "Content-module-sass-module__NT-RwW__Cont",
  "Content": "Content-module-sass-module__NT-RwW__Content",
  "Copy": "Content-module-sass-module__NT-RwW__Copy",
});
